<!-- eslint-disable -->
<template lang="pug">
    .form-group(
        :class=`{
            'form-group--error': error
        }`
    )
        .form-group__grid
            .form-group__label-wrapper(v-if="label")
                label.form-group__label(v-text="label")
            .form-group__item-wrapper(
                :class=`{
                    'form-group__item-wrapper--offset': !label && offset,
                    'form-group__item-wrapper--fullwidth': !label && !offset
                }`
            )
                slot.form-group__item
            .form-group__help-text(
                v-if="$slots['help-text']"
                :class=`{
                    'form-group__help-text--fullwidth': !label && !offset,
                }`
            )
                slot(name="help-text")
</template>

<script>
    /*eslint-disable*/
    /**
     * Form Groups are used to allow users to provide text input when the expected
     * input is short. Form Input has a range of options and supports several text
     * formats including numbers. For longer input, use the `FormTextarea` element.
     */
    export default {
        name: "FormGroup",
        status: "ready",
        release: "1.0.0",
        props: {
            /**
             * The label of the form input field.
             */
            label: {
                type: String,
                default: "",
            },
            /**
             * The error state of input field.
             */
            error: {
                type: String,
                default: "",
            },
            /**
             * Set the offset of input(if label is not set).
             */
            offset: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style lang="scss" scoped>
    $grid-gutter: $space-x-small;

    .form-group {
        @include reset;

        @include stack-space($space-small);

        .form-group__grid {
            @include make-grid($grid-gutter);
            align-items: center;
        }

        .form-group__label-wrapper {
            justify-content: flex-end;
            @include make-col(3, 3, $grid-gutter);
            @include media ($md) {
                text-align: right;
                @include make-col(1, 3, $grid-gutter);
            }
        }

        .form-group__help-text {
            @include text($font-size-12);
            @include make-col(3, 3, $grid-gutter);
            @include media ($md) {
                @include make-offset(1, 3);
                @include make-col(2, 3, $grid-gutter);
            }
            &--fullwidth {
                @include make-offset(0, 3);
            }
        }

        .form-group__label {
            @include text($font-size-16);
            color: $color-shark;
        }

        .form-group__item-wrapper {
            @include make-col(3, 3, $grid-gutter);
            @include media ($md) {
                @include make-col(2, 3, $grid-gutter);
            }
            &--offset {
                @include media ($md) {
                    @include make-offset(1, 3);
                }
            }
            &--fullwidth {
                @include media ($md) {
                    @include make-col(3, 3, $grid-gutter);
                }
            }
        }
    }
</style>


<docs>
```jsx
<div>
    <form-group label="Input">
        <cs-input type="text" placeholder="First name"/>
    </form-group>
    <form-group label="Input">
        <cs-input type="email" error value="Text"/>
        <help-text slot="help-text" error>Please enter correct email!</help-text>
    </form-group>
    <form-group>
        <cs-input type="text" placeholder="First name"/>
        <help-text slot="help-text" error>Please enter correct email!</help-text>
    </form-group>
    <form-group offset>
        <checkbox>I'm a checkbox</checkbox>
        <help-text slot="help-text" error>Please enter correct email!</help-text>
    </form-group>
</div>
```
</docs>
